/**
 * Transaction Module
 *
 * Provides transaction state management and currency utilities for the DreamPay platform.
 *
 * @module transaction
 *
 * @example
 * ```typescript
 * import {
 *   TransactionState,
 *   deriveTransactionState,
 *   getStateColor,
 *   getStateSeverity,
 *   getStateLabel,
 *   CurrencyUtil
 * } from 'shared';
 *
 * // Derive state from API transaction
 * const state = deriveTransactionState(transaction);
 *
 * // Get display properties
 * const color = getStateColor(state);
 * const severity = getStateSeverity(state);
 * const label = getStateLabel(state);
 *
 * // Currency calculations
 * const total = CurrencyUtil.add('10.50', '5.25');
 * const formatted = CurrencyUtil.format(1234.56, 'BRL', 'pt-BR');
 * ```
 */
export * from './models';
export * from './utils';
